var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$config.platform === 'ds')?_c('HomePageV2',{attrs:{"data":_vm.pageData}}):_c('HomePage',{attrs:{"data":_vm.pageData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }